/* ==========================================================================
   Neopot — checkout button safety net.

   The theme's checkout button is:

     <button type="submit" id="checkout" name="checkout" form="cart-form">

   It does not contain its own form. It reaches out by id to a form rendered
   elsewhere in the cart markup. Whenever that form is missing, is rendered
   twice (so getElementById resolves the stale copy), or has been detached by
   a section re-render, the browser has nothing to submit and the tap does
   absolutely nothing — no error, no navigation. That is the bug this fixes.

   Strategy: let the native submit run first, because it carries the cart note
   and any discount code. Then watch. If the page has not begun navigating a
   short moment later, the submit went nowhere and we send the shopper to
   /checkout ourselves. When the native path works, the unload cancels the
   watchdog and this file changes nothing.
   ========================================================================== */

(function () {
  'use strict';

  var CHECKOUT_URL = '/checkout';
  var GRACE_MS = 700;

  var leaving = false;
  var timer = null;

  function markLeaving() {
    leaving = true;
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  }

  // Any of these means a navigation really did start.
  window.addEventListener('pagehide', markLeaving);
  window.addEventListener('beforeunload', markLeaving);
  window.addEventListener('unload', markLeaving);

  function resolveForm(button) {
    var id = button.getAttribute('form');
    if (!id) return button.closest('form');

    // Collect every match, not just the first: a duplicated id is one of the
    // failure modes, and getElementById would hand back the stale one.
    var all = document.querySelectorAll('form[id="' + id + '"]');
    for (var i = 0; i < all.length; i++) {
      var form = all[i];
      // offsetParent is null for anything display:none or detached.
      if (form.isConnected && form.offsetParent !== null) return form;
    }
    return all.length ? all[0] : null;
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var button = target.closest('#checkout, .cart__checkout-button, [name="checkout"]');
      if (!button || button.disabled) return;

      var form = resolveForm(button);

      // No usable form at all: do not wait, go straight there.
      if (!form) {
        event.preventDefault();
        markLeaving();
        window.location.href = CHECKOUT_URL;
        return;
      }

      // A form exists, so let it try. Arm the watchdog behind it.
      leaving = false;
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () {
        timer = null;
        if (leaving) return;
        if (document.visibilityState === 'hidden') return;
        window.location.href = CHECKOUT_URL;
      }, GRACE_MS);
    },
    true
  );
})();
